module.exports = __webpack_public_path__ + "media/error-129258.16d31e4f.mp3";